import script from "./UserActionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserActionModal.vue?vue&type=script&setup=true&lang=ts"

import "./UserActionModal.css?vue&type=style&index=0&id=94f2016a&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94f2016a"]])

export default __exports__